import { render, staticRenderFns } from "./AssignModal.vue?vue&type=template&id=15dff870&"
import script from "./AssignModal.vue?vue&type=script&lang=js&"
export * from "./AssignModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15dff870')) {
      api.createRecord('15dff870', component.options)
    } else {
      api.reload('15dff870', component.options)
    }
    module.hot.accept("./AssignModal.vue?vue&type=template&id=15dff870&", function () {
      api.rerender('15dff870', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/AssignModal.vue"
export default component.exports